{
	"views": {
		"articles": {
			"list": {
				"columns": ["title", "author", "categories", "status", "createdOn", "createdBy"]
			}
		},
		"events": {
			"list": {
				"columns": [
					"title",
					"type",
					{"name": "startDateTime", "title": "start" },
					{"name": "endDateTime", "title": "end" },
					"status",
					"createdOn",
					"createdBy"
				]
			}
		},
		"profiles": {
			"list": {
				"columns": ["fullName", "roles", "status", "createdOn", "createdBy"]
			}
		},
		"users": {
			"list": {
				"columns": ["fullName", "email", "role", "status", "registerDate", "lastLoginDate"]
			}
		},
		"contacts": {
			"list": {
				"columns": [
					"name",
					"email",
					"reason",
					"eventTitle",
					"status",
					"emailSent",
					"createdOn"
				]
			}
		}
	},
	"collections": {
		"users": {
			"model": "User"
		},
		"profiles": {
			"model": "Profile",
			"i18n": ["fullName", "about"],
			"schema": {
				"fullName": "Mixed",
				"email": "String",
				"slug": "String",
				"avatar": "String",
				"about": "Mixed",
				"roles": ["String"],
				"status": { "type": "String", "enum": ["draft", "published", "archived"], "default": "draft" },
				"address": {
					"street": "String",
					"city": "String",
					"zip": "String",
					"country": "String",
					"geo": {
						"lat": "Number",
						"lng": "Number"
					}
				},
				"links": [{
					"type": { "type": "String", "enum": ["facebook", "instagram", "soundcloud", "mixcloud", "github", "bandcamp", "youtube", "website", "other"] },
					"url": "String"
				}],
				"tracks": [{
					"title": "String",
					"source": { "type": "String", "enum": ["upload", "soundcloud", "mixcloud", "external"] },
					"url": "String",
					"duration": "Number"
				}],
				"videos": [{
					"title": "String",
					"source": { "type": "String", "enum": ["upload", "youtube", "vimeo", "external"] },
					"url": "String"
				}],
				"pictures": ["String"],
				"user": { "type": "ObjectId", "ref": "User", "required": false },
				"createdBy": { "type": "ObjectId", "ref": "User", "required": false },
				"createdOn": { "type": "Date", "default": "Date.now" }
			}
		},
		"articles": {
			"model": "Article",
			"i18n": ["title", "text"],
			"schema": {
				"title": "Mixed",
				"slug": "String",
				"text": "Mixed",
				"status": { "type": "String", "enum": ["draft", "published"] },
				"author": "String",
				"categories": ["String"],
				"pinned": "Boolean",
				"createdBy": { "type": "ObjectId", "ref":"User", "required": false},
				"createdOn": { "type": "Date", "default": "Date.now" }
			}
		},
		"events": {
			"model": "Event",
			"i18n": ["title", "text"],
			"schema": {
				"title": "Mixed",
				"slug": "String",
				"text": "Mixed",
				"type": { "type": "String", "enum": [
					"jam-session", "festival", "performance",
					"talks", "conference", "lecture", 
					"tinkering", "workshop"
				]},
				"startDateTime": "Date",
				"endDateTime": "Date",
				"timezone": { "type": "String", "default": "Europe/Sofia" },
				"poster": "String",
				"links": ["String"],
				"status": { "type": "String", "enum": ["draft", "published", "archived", "canceled"], "default": "draft" },
				"venue": {
					"profile": { "type": "ObjectId", "ref": "Profile", "required": false },
					"name": "Mixed",
					"address": {
						"street": "String",
						"city": "String",
						"zip": "String",
						"country": "String",
						"geo": {
							"lat": "Number",
							"lng": "Number"
						}
					}
				},
				"participants": [{
					"role": { "type": "String", "enum": ["organizer", "lecturer", "performer"] },
					"profile": { "type": "ObjectId", "ref": "Profile", "required": false}
				}],
				"subEvents": [ { "type": "ObjectId", "ref":"Event" } ],
				"createdBy" : { "type": "ObjectId", "ref":"User", "required": false},
				"createdOn": { "type": "Date", "default": "Date.now" }
			}
		},
		"pages": {
			"model": "Page",
			"i18n": ["title", "content"],
			"schema": {
				"title": "Mixed",
				"path": "String",
				"content": "Mixed",
				"createdBy" : { "type": "ObjectId", "ref":"User", "required": false},
				"createdOn": { "type": "Date", "default": "Date.now" }
			}
		},
		"contacts": {
			"model": "Contact",
			"schema": {
				"name": "String",
				"email": "String",
				"reason": { "type": "String", "enum": ["general", "event"], "default": "general" },
				"event": { "type": "ObjectId", "ref": "Event", "required": false },
				"eventTitle": "String",
				"message": "String",
				"status": { "type": "String", "enum": ["new", "read", "archived"], "default": "new" },
				"emailSent": "Boolean",
				"createdOn": { "type": "Date", "default": "Date.now" }
			}
		}
	},
	"routes": {
		"api" : {
			"_meta": {
				"virtual": true,
				"crud": true,
				"contentType": "json"
			},
			"users": {
				"_meta": {
					"access": {
						"admin": "all",
						"publisher": "own",
						"user": "list,read",
						"anonymous": "create"
					}
				}
			},
			"profiles": {
				"_meta": {
					"access": {
						"admin": "all",
						"publisher": "own",
						"user": "list,read",
						"anonymous": "list,read"
					}
				}
			},
			"articles": {
				"_meta": {
					"access": {
						"admin": "all",
						"publisher": "own",
						"user": "list,read",
						"anonymous": "list,read"
					}
				}
			},
			"events": {
				"_meta": {
					"access": {
						"admin": "all",
						"publisher": "own",
						"user": "list,read",
						"anonymous": "list,read"
					}
				}
			},
			"pages": {
				"_meta": {
					"access": {
						"admin": "all",
						"publisher": "own",
						"user": "list,read",
						"anonymous": "list,read"
					}
				}
			},
			"contacts": {
				"_meta": {
					"access": {
						"admin": "all",
						"publisher": "list,read"
					}
				}
			}
		}
	}
}
